import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../healthpicks-operator.constants';

@Component({
  selector: 'app-healthpicks-operator-change-password-sent',
  templateUrl: './healthpicks-operator-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './healthpicks-operator-change-password-sent.component.css',
  ],
})
export class HealthpicksOperatorChangePasswordSentComponent implements OnInit {
  email: string | null;

  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}

  returnToList(): void {
    history.back();
  }
}
